var isUnstable = function isUnstable(name) {
  return (// eslint-disable-next-line no-console
    console.log("%c".concat(name, " is currently in development and considered unstable. For more information, contact NT_UI_DEV@ntrs.com"), 'color: black; background-color: yellow;')
  );
};

export default isUnstable;